import React from 'react'

function Error(){
  return (
    <>
    <div className='contact-box'>
    <div className='contact-main'>
    <div className='error-msg'>
    <p>☣ Page not found! ☣</p>
    </div>
    </div>
    </div>
    </>
  );
}
export default Error;